import { createRouter, createWebHistory } from 'vue-router';
import Login from './pages/Login.vue';
import Layout from './components/Layout.vue';
import Dashboard from './pages/Dashboard.vue';
import Category from './pages/Category.vue';
import Product from './pages/Product.vue';
import UpdateProduct from './pages/UpdateProduct.vue';
import Order from './pages/Order.vue';
import Promo from './pages/Promo.vue';
import User from './pages/User.vue';
import Affiliate from './pages/Affiliate.vue';
import Setting from './pages/Setting.vue';
import Analysis from './pages/Analysis.vue';
import QuizCategory from './pages/QuizCategory.vue';
import QuizQuestion from './pages/QuizQuestion.vue';
import Media from './pages/Media.vue';
import Feedback from './pages/Feedback.vue';
import Withdrawal from './pages/Withdrawal.vue';
import License from './pages/License.vue';
import AutoPost from './pages/AutoPost.vue';

const routes = [
  {
    path: '/',
    redirect: () => {
      // Nếu đã login thì redirect tới dashboard, nếu chưa thì về login
      const token = localStorage.getItem('token');
      return token ? '/admin/dashboard' : '/login';
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Layout,
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: 'category',
        name: 'Category',
        component: Category,
      },
      {
        path: 'product',
        name: 'Product',
        component: Product,
      },
      {
        path: 'update-product/:id',
        name: 'UpdateProduct',
        component: UpdateProduct,
      },
      {
        path: 'order',
        name: 'Order',
        component: Order,
      },
      {
        path: 'promo',
        name: 'Promo',
        component: Promo,
      },
      {
        path: 'user',
        name: 'User',
        component: User,
      },
      {
        path: 'affiliate',
        name: 'Affiliate',
        component: Affiliate,
      },
      {
        path: 'setting',
        name: 'Setting',
        component: Setting,
      },
      {
        path: 'analysis',
        name: 'Analysis',
        component: Analysis,
      },
      {
        path: 'quiz-category',
        name: 'QuizCategory',
        component: QuizCategory,
      },
      {
        path: 'quiz-question',
        name: 'QuizQuestion',
        component: QuizQuestion,
      },
      {
        path: 'media',
        name: 'Media',
        component: Media,
      },
      {
        path: 'feedback',
        name: 'Feedback',
        component: Feedback,
      },
      {
        path: 'withdrawal',
        name: 'Withdrawal',
        component: Withdrawal,
      },
      {
        path: 'license',
        name: 'License',
        component: License,
      },
      {
        path: 'auto-post',
        name: 'AutoPost',
        component: AutoPost,
      },
    ]
  },
  {
    // Catch-all route cho 404 errors
    path: '/:pathMatch(.*)*',
    redirect: () => {
      const token = localStorage.getItem('token');
      return token ? '/admin/dashboard' : '/login';
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard để kiểm tra authentication
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const isLoggedIn = !!token;

  // Nếu đã login và đang cố truy cập login page
  if (isLoggedIn && to.path === '/login') {
    next('/admin/dashboard');
    return;
  }

  // Nếu chưa login và đang cố truy cập admin pages
  if (!isLoggedIn && to.path.startsWith('/admin')) {
    next('/login');
    return;
  }

  // Cho phép navigation bình thường
  next();
});

export default router; 